import React, {Component} from "react";
import {TextInput} from "../../../components";
import {Button} from "react-bootstrap";
import RemotingService from "../../../services/remoting-service/RemotingService";
import {FormField} from "../../../components/form";
import ValidationUtil from "../../../components/form/validator/ValidationUtil";
import AuthService from "../../../services/auth-service/AuthService";

export default class ForgotPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: null,
            captchaToken: null,
            requestSent: false
        }
    }

    componentDidMount() {
        if (AuthService.isAuthenticated()) {
            AuthService.logout();
            window.location.reload();
        }

        this.loadTurnstileScript();
    }

    getTurnstileSiteKey() {
        return process.env.REACT_APP_TURNSTILE_SITE_KEY
            || '3x00000000000000000000FF';// dummy key that forces an interactive challenge
    }

    loadTurnstileScript() {
        if (window.turnstile) {
            this.renderTurnstile();
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
        script.async = true;
        script.defer = true;
        script.onload = () => {
            this.renderTurnstile();
        };
        script.onerror = () => {
            console.warn('Turnstile failed to load');
        };
        document.head.appendChild(script);
    }

    renderTurnstile() {
        if (window.turnstile && !this.turnstileWidgetId) {
            try {
                const siteKey = this.getTurnstileSiteKey();

                this.turnstileWidgetId = window.turnstile.render('#turnstile-container', {
                    sitekey: siteKey,
                    callback: (token) => {
                        this.setState({captchaToken: token});
                    },
                    'expired-callback': () => {
                        console.log('Turnstile verification expired');
                        this.setState({captchaToken: null});
                    },
                    'error-callback': () => {
                        console.log('Turnstile verification error');
                        this.setState({captchaToken: null});
                    },
                    theme: 'light',
                    size: 'normal'
                });
            } catch (error) {
                console.error('Failed to render Turnstile widget:', error);
            }
        }
    }

    resetPassword = () => {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        if (!this.state.captchaToken) {
            ValidationUtil.showNotification('Please wait for security verification to complete', 'error');
            return;
        }

        const requestData = {
            email: this.state.email,
            captchaToken: this.state.captchaToken
        };

        RemotingService.postRemoteCall('api/public/auth/forgot-password', requestData, () => {
            this.setState({requestSent: true});
            if (window.turnstile && this.turnstileWidgetId) {
                window.turnstile.reset(this.turnstileWidgetId);
            }
        }, (error) => {
            if (window.turnstile && this.turnstileWidgetId) {
                window.turnstile.reset(this.turnstileWidgetId);
            }
            this.setState({captchaToken: null});
        });
    }

    render() {
        this.formFields = [];

        return (
            <div className="container" style={{width: "28rem"}}>
                <div className="row d-flex p-justify-center mb-4">
                    <h3>Forgot Your Password?</h3>
                </div>

                <div className="row mb-3">
                    <div className="col-3">
                        <label className="form-label">Email</label>
                    </div>
                    <div className="col-9">
                        <FormField ref={formField => this.formFields.push(formField)}
                                   required email
                                   validateOn={this.state.email}>
                            <TextInput className="w-100"
                                       disabled={this.state.requestSent}
                                       value={this.state.email}
                                       placeholder="Enter your email address"
                                       onChange={value => this.setState({email: value})}/>
                        </FormField>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-12 d-flex justify-content-center">
                        <div id="turnstile-container"
                             style={{
                                 opacity: this.state.requestSent ? 0.5 : 1,
                                 pointerEvents: this.state.requestSent ? 'none' : 'auto'
                             }}>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col d-flex justify-content-end">
                        <Button disabled={this.state.requestSent || !this.state.captchaToken}
                                variant={this.state.requestSent ? "success" : "primary"}
                                onClick={this.resetPassword}>
                            {this.state.requestSent ? "Reset Link Sent!" : "Reset My Password"}
                        </Button>
                    </div>
                </div>

                {this.state.requestSent && (
                    <div className="row mt-3">
                        <div className="col">
                            <div className="alert alert-success">
                                <strong>Password reset link sent!</strong>
                                <br/>
                                Please check your email for instructions to reset your password.
                                If you don't see it, check your spam folder.
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }

}